import { useMemo } from 'react';
import { RouteObject } from 'react-router-dom';

import { mapRouteBuilderToRoutes } from 'app/routes/routeBuilder';
import { useAuthState, useHasActiveCompany } from 'app/state/AuthContext/hooks';

import { AdminLayout, DefaultRedirect, FourOhFour } from './AdminRouteComponents';
import { reportsRoutes } from './reportsRoutes';
import {
  adminActionsRoutes,
  brokerAccountMatchingRoutes,
  brokerCarrierMatchingRoutes,
  carrierActionsRoutes,
  factorClientMatchingRoutes,
  factorDebtorMatchingRoutes,
  miscellaneousRoutes,
  noaRoutes,
  payorRoutes,
  promotionalCampaignRoutes,
  selectCarrierRoutes,
  serverSettingsRoutes,
  setupRoutes,
} from '.';

export const useGetAdminRoutes = (): RouteObject[] => {
  const { authRoles } = useAuthState();

  const hasActiveCompany = useHasActiveCompany();

  const localAdminRoutes = useMemo(() =>
    [
      {
        element: <DefaultRedirect />,
        path: '',
      },
      ...mapRouteBuilderToRoutes({
        authRoles,
        items: hasActiveCompany
          ? [
            ...adminActionsRoutes,
            ...brokerAccountMatchingRoutes,
            ...brokerCarrierMatchingRoutes,
            ...carrierActionsRoutes,
            ...factorClientMatchingRoutes,
            ...factorDebtorMatchingRoutes,
            ...miscellaneousRoutes,
            ...noaRoutes,
            ...payorRoutes,
            ...promotionalCampaignRoutes,
            ...reportsRoutes,
            ...selectCarrierRoutes,
            ...serverSettingsRoutes,
            ...setupRoutes,
          ]
          : [
            ...noaRoutes,
          ],
      }),
      {
        element: <FourOhFour />,
        path: '*',
      },
    ],
  [authRoles, hasActiveCompany]);

  return useMemo(() => [
    {
      children: localAdminRoutes,
      element: <AdminLayout />,
      path: '/admin',
    },
  ],
  [localAdminRoutes]);
};
